import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { dischargedMember } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetDischargedMember = (props, enabled) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}organizations/backoffice/discharge/details`, { ...additional, params: { ...props } }),
        queryKey: [dischargedMember],
        enabled
    });
};
export default useGetDischargedMember;
